import {
  CustomButton,
  SearchBar,
  SwitchButton,
  searchDateFormat,
} from "components/form";
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CustomModal, PopupModal } from "components/modals/ModalBox";
import { dateFormat, dateFormatWithTime } from "utils/dateFormat";
import Pagination from "react-js-pagination";
import useFullPageLoader from "common/UseFullPageLoader";
import useButtonLoader from "common/UseButtonLoader";
import { FaRegEdit, FaRegTrashAlt, FaRegEye } from "react-icons/fa";
import useDebounce from "common/UseDebounce";
import { toastMessage } from "utils/toastMessage";
import NotFound from "common/NotFound";
import { DatePicker, timeFormat } from "common/InputForm";
import { toast } from "sonner";
import { userPlaceholder } from "assets/icons";
import "./postManagement.scss";
import { blogListApi, removeBlogApi, updateBlogStatus } from "services/blog";
import { masterClothingCategoriesListApi } from "services/master";
const BlogManagement = () => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [blogList, setBlogList] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);
  const [fieldName, setFieldName] = useState("");
  const [direaction, setDirection] = useState("");
  const [buttonLoaderFile, setButtonLoaderFile] = useButtonLoader("Export");
  const [searchParams, setSearchParams] = useSearchParams();
  const [selected, setSelected] = useState({});
  const [statusModal, setStatusModal] = useState(false);
  const [total, setTotal] = useState(null);
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Yes");
  const activePage = +searchParams.get("page") || 1;
  let searchStartDate = searchParams.get("startDate") || "";
  let searchEndDate = searchParams.get("endDate") || "";
  let hashtag = searchParams.get("title") || "";
  const limits = +searchParams.get("limit") || 10;
  const statusValue = searchParams.get("status") || "";
  const createdByValue = searchParams.get("createdBy") || "";
  const trendingValue = searchParams.get("trendingValue") || "";

  const [descriptionModal, setDescriptionModal] = useState(false);
  const [description, setDescription] = useState("");
  const batchValue = searchParams.get("batch") || "";
  const batchId = searchParams.get("batchId") || "";
  const groupValue = searchParams.get("group") || "";
  const [imagePreview, setImagePreview] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [loader, onShow, onHide] = useFullPageLoader();
  const categoryValue = searchParams.get("category") || "";
  const [categoryList, setCategoryList] = useState([]);

  // sort
  const toggleSortOrder = () => {
    setDirection(direaction === "ASC" ? "DESC" : "ASC");
  };
  const handleSort = (field) => {
    if (field === fieldName) {
      toggleSortOrder();
    } else {
      setFieldName(field);
      setDirection("ASC");
    }
  };
  // delete handler
  const deleteHandler = (id) => {
    setSelected({ id, action: "delete" });
    setDeleteModal(true);
  };
  // change delete handler
  const changeDeleteHandler = async () => {
    try {
      setButtonLoaders(true);
      const res = await removeBlogApi(selected.id);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "delete");
        searchParams.delete("page");
        blogListHandler();
        setDeleteModal(false);
      } else {
        toastMessage(res.data.message, "error", "delete");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoaders(false);
    }
  };
  // change student status
  const statusHandler = (id, status) => {
    setSelected({
      ...selected,
      id,
      status: status === "true" ? "false" : "true",
    });
    setStatusModal(true);
  };
  /**************Change Status Handler*********************/
  const changeStatusHandler = async () => {
    try {
      setButtonLoader(true);
      const res = await updateBlogStatus(selected);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "changeStatus");
        setStatusModal(false);
        blogListHandler();
      } else {
        toastMessage(res.data.message, "error", "changeStatus");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };
  // //*********start Date search********* */
  const handleStartDate = (date) => {
    searchParams.set("page", 1);
    searchParams.set("startDate", searchDateFormat(date));
    setSearchParams(searchParams);
  };
  // //*********end Date search********* */
  const handleEndDate = (date) => {
    searchParams.set("page", 1);
    searchParams.set("endDate", searchDateFormat(date));
    setSearchParams(searchParams);
  };
  /*************Reset Filter Handler*********************/
  const resetFilterHandler = () => {
    searchParams.delete("status");
    searchParams.delete("page");
    searchParams.delete("startDate");
    searchParams.delete("createdBy");
    searchParams.delete("endDate");
    setSearch("");
    setSearchParams(searchParams);
  };
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };
  /**************Modal CLose*********************/
  const closeModal = () => {
    setStatusModal(false);
    setSelected({});
  };
  //-----------status-------------
  const handleStatus = (event) => {
    const value = event.target.value;
    searchParams.set("status", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };
  const handleTrending = (event) => {
    const value = event.target.value;
    searchParams.set("trendingValue", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };

  // student list handler
  const blogListHandler = async (
    page = activePage,
    limit = limits,
    search = debouncedValue,
    sortField = fieldName || "",
    sortDirection = direaction,
    startDate = searchStartDate,
    endDate = searchEndDate,
    status = statusValue,
    category = categoryValue,
    isTrending = trendingValue,
    // batchStatus = batchValue,
    // batch = batchId,
    // group = groupValue,
    // createdBy = createdByValue,
    // hashTags = hashtag
  ) => {
    try {
      onShow();
      const res = await blogListApi({
        page,
        search,
        limit,
        sortField,
        sortDirection,
        startDate,
        endDate,
        status,
        category,
        isTrending
        // batchStatus,
        // batch,
        // group,
        // createdBy,
        // hashTags,
      });
      console.log(res.data?.data, "res");
      if (res?.status === 200) {
        setTotal(res.data.data.total);
        setBlogList(res.data?.data.blogs);
        onHide();
      } else {
        toastMessage(res?.data?.message, "error", "bloglist");
      }
    } catch (e) {
      onHide();
      toast.error(e.message);
    }
  };
  const handleCategory = (event) => {
    const value = event.target.value;
    searchParams.set("category", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };
  const categoryListHandler = async () => {
    try {
      const res = await masterClothingCategoriesListApi();

      if (res?.data?.status === 200) {
        setCategoryList(res.data?.data?.categories);
      } else {
        toastMessage(res?.data?.message, "error", "categoryList");
      }
    } catch (e) {
      toastMessage(e.message, "error", "categoryList");
    }
  };
  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParams.delete("page");
      setSearchParams(searchParams);
    }
    blogListHandler();
  }, [
    // searchParams,
    debouncedValue,
    fieldName,
    direaction,
    activePage,
    searchStartDate,
    searchEndDate,
    statusValue,
    batchValue,
    batchId,
    categoryValue,
    groupValue,
    hashtag,
    createdByValue,
    trendingValue
  ]);
  useEffect(() => {
    categoryListHandler();
  }, []);
  useEffect(() => {
    if (search) {
      searchParams.delete("page");
    }
  }, []);
  return (
    <>
      <div className="student_management">
        <div className="card top_card">
          <div className="dashboard_title has_child">
            <h3>Blog Management</h3>
            <div className="d-flex">
              <Link
                to="/blog-management/add"
                className="MuiButtonBase-root MuiButton-root MuiButton-contained button mx-2"
              >
                Add Blog
              </Link>
            </div>
          </div>
          <div className="button_section_wrap">
            <div className="search_wrapper">
              <SearchBar
                placeholder={"Search..."}
                onChange={(e) => {
                  setSearch(e.target.value);
                  searchParams.delete("page");
                  setSearchParams(searchParams);
                }}
                value={search}
              />
              <div className="d-flex align-items-center">
                <select
                  className="input form-control"
                  value={statusValue}
                  onChange={handleStatus}
                >
                  <option value={""}>Select Status</option>
                  <option value="true">Active</option>
                  <option value="false">In Active</option>
                </select>
                {/* <select
                  className="input form-control"
                  value={trendingValue}
                  onChange={handleTrending}
                >
                  <option value={""}>Select Trending</option>
                  <option value="true">True</option>
                  <option value="false">False</option>
                </select> */}
                <select
                  className="input form-control"
                  type="text"
                  value={categoryValue || ""}
                  name="category"
                  onChange={handleCategory}
                >
                  <option value={""}>Select Category</option>
                  {categoryList.map((data) => (
                    <option key={data._id} value={data.name}>
                      {data.name}
                    </option>
                  ))}
                </select>
                <DatePicker
                  name="startDate"
                  selected={searchStartDate}
                  placeholder="Start Date"
                  onChange={(date) => handleStartDate(date)}
                  maxDate={searchEndDate}
                />
                <DatePicker
                  name="endDate"
                  placeholder="End Date"
                  selected={searchEndDate}
                  onChange={(date) => handleEndDate(date)}
                  minDate={searchStartDate}
                />
                <CustomButton onClick={resetFilterHandler}>Reset</CustomButton>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table_wrap ">
              <table className="table custom_table">
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Image</th>
                    <th
                      className="nowrap cursor-pointer text-center"
                      onClick={() => handleSort("title")}
                    >
                      Title
                      <span className="shorting">
                        {fieldName === "title"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th>Published Date </th>

                    <th>Status</th>
                    <th className="nowrap text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loader}
                  {blogList && blogList?.length > 0 ? (
                    blogList?.map((data, index) => {
                      // console.log(data, "datvva");
                      return (
                        <tr key={++index}>
                          {/* <td>{index + 1}</td> */}
                          <td >{++index + (activePage - 1) * 10}</td>
                          <td className="nowrap">
                            {data.media && data.media.length > 0 && (
                              <button
                                type="button"
                                onClick={() => {
                                  setImagePreview(true);
                                  setImageUrl(
                                    data.media[0].type === "image"
                                      ? data.media[0].url
                                      : data.media[0].thumb
                                  );
                                }}
                              >
                                <img
                                  src={
                                    data.media[0].type === "image"
                                      ? data.media[0].url
                                      : data.media[0].thumb
                                  }
                                  className="poster"
                                  alt=""
                                />
                              </button>
                            )}
                          </td>

                          <td className="text-center">
                            {data?.title} {data?.isTrending && <subp className="trending-badge">Trending</subp>}
                          </td>
                          <td className="nowrap">
                            {dateFormatWithTime(data?.createdAt)}
                          </td>
                          <td className="text-center">
                            <Link
                              className="icon_button justify-content-center"
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                statusHandler(
                                  data._id,
                                  data?.status.toString()
                                );
                              }}
                            >
                              <SwitchButton status={data?.status.toString()} />
                            </Link>
                          </td>
                          <td className="text-center">
                            <div className="icon_wrap">
                              <Link
                                to={`/blog-management/detail/${data?._id}`}
                                className="icon_button"
                              >
                                <FaRegEye />
                              </Link>

                              <Link
                                className="icon_button"
                                to={`/blog-management/edit/${data?._id}`}
                              >
                                <FaRegEdit />
                              </Link>
                              <Link
                                className="icon_button"
                                to=""
                                onClick={(e) => {
                                  e.preventDefault();
                                  deleteHandler(data?._id);
                                }}
                              >
                                <FaRegTrashAlt />
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NotFound
                      cols={7}
                      msg={"Blog data not found"}
                      onHide={onHide}
                    />
                  )}
                </tbody>
              </table>
            </div>
            {total > limits && (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limits}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Delete Blog Modal */}
      <PopupModal
        show={deleteModal}
        handleClose={() => {
          setSelected({});
          setDeleteModal(false);
        }}
        content="Are you sure you want to delete this Blog?"
        title="Delete Blog"
        onShow={changeDeleteHandler}
        buttonLoader={buttonLoaders}
      />
      <PopupModal
        show={statusModal}
        handleClose={closeModal}
        content="Are you sure you want to change status of this Blog?"
        title="Change Blog"
        onShow={changeStatusHandler}
        buttonLoader={buttonLoader}
      />
      <CustomModal
        className={"image_preview_modal"}
        show={imagePreview}
        handleClose={() => setImagePreview(false)}
      >
        <div className="image_preview">
          <img src={imageUrl ? imageUrl : userPlaceholder} alt="" />
        </div>
      </CustomModal>

      {descriptionModal && (
        <CustomModal
          className={"add_model"}
          show={descriptionModal}
          handleClose={() => {
            setDescriptionModal(false);
          }}
        >
          <h3>Description</h3>
          <h7>{description}</h7>
        </CustomModal>
      )}
    </>
  );
};

export default BlogManagement;
